import "./footer.css";

import React from "react";
import { Link, useLocation } from "react-router-dom";

import useStore from "stores/Store";

import PIDM_DIS from "assets/pdf/PIDM_DIS.pdf";
import tnc from "assets/pdf/website_terms_of_use.pdf";
import fees from "assets/pdf/All-Fees-Charges2.pdf";

import alrajhi_logo from "assets/images/alrajhi_logo.svg";
import rize_logo from "assets/images/rize_logo.svg";
import pidm_logo from "assets/images/pidm_logo.svg";

const MainFooter = () => {
  const location = useLocation();
  const { pathname } = location;
  const { setShowTips } = useStore();

  return (
    <div id="footer" className="mt-5">
      <div className="footer">
        <div className="container footer-top">
          <div className="row gy-5">
            <div className="'row g-3"></div>
            <div className="col-lg-2 d-flex flex-lg-column flex-row align-items-center justify-content-lg-start justify-content-center">
              <a href="/" className="logo d-flex align-items-center">
                <img
                  src={alrajhi_logo}
                  width="145"
                  className="d-inline-block align-top"
                  alt="Al Rajhi logo"
                  style={{ paddingRight: "16px" }} // Adjust spacing as needed
                />
              </a>
              <img
                src="https://www.alrajhibank.com.my/assets/images/gallery/new_rize_logo.svg"
                width="auto"
                className="rize-logo d-inline-block align-top"
                alt="Rize logo"
                // style={{ paddingTop: "24px" }}
              />
            </div>

            <div className="col-lg-2 col-6 footer-links al">
              <h4 data-translate="footer_1_1">I need to know</h4>
              <div className="links">
                <Link to="/foreign-exchange-rates">Exchange Rates</Link>

                <Link to="/gold-price">Gold Price</Link>

                <Link to="/unit-trust-price">
                  <span data-translate="footer_1_4">Unit Trusts-</span>
                  <em>i</em>
                </Link>

                <Link to="/e-application-form">e-Application Form</Link>

                <Link
                  to={
                    "https://www.alrajhibank.com.my/assets/pdf/feesandcharges/Tariff_Charges.pdf"
                  }
                  target="blank"
                >
                  Fees and Charges
                </Link>

                <Link to="/negative-list">Negative List</Link>

                <Link to="/list-of-insured-deposits">
                  List of Insured Deposits
                </Link>

                <Link to="/auctions">Auctions</Link>

                <Link to="/about/corporate-governance/compliance">
                  Personal Data Protection Notice
                </Link>

                <Link to="/about/corporate-governance/whistleblow">
                  Whistleblowing Policy
                </Link>

                <Link onClick={() => setShowTips(true)}>Security Tips</Link>
              </div>
            </div>

            <div className="col-lg-2 col-6 footer-links">
              <h4 data-translate="footer_2_1">Promotions</h4>
              <div className="links">
                <Link to="/personal/cards/debit-card">
                  <span>Debit Card-</span>
                  <em>i</em>
                </Link>
              </div>
            </div>

            <div className="col-lg-2 col-6 footer-links">
              <h4 data-translate="footer_3_1">Wealth Management</h4>
              <div className="links">
                <Link to="/personal/wealth/gold-i">
                  <span>Gold-</span>
                  <em>i</em>
                </Link>

                <Link to="/personal/wealth/gold-invest">
                  <span>GoldInvest-</span>
                  <em>i</em>
                </Link>

                <Link to="/personal/wealth/unit-trust">Unit Trust</Link>

                <Link to="/personal/wealth/sinar-kasih">BancaTakaful</Link>

                <Link to="/personal/wealth/structured-product">
                  Structured Product-<em>i</em>
                </Link>

                <Link to="/personal/wealth/will-writing">Will Writing</Link>

                <Link to="/personal/wealth/safe-deposit-box">
                  Safe Deposit Box-<i>i</i>
                </Link>
              </div>
            </div>

            <div className="col-lg-2 col-6 footer-links">
              <h4 data-translate="footer_4_1">Corporate Info</h4>
              <div className="links">
                <Link to="/about">About Us</Link>
                {/* <Link to="/about/corporate-info/our-background">Our Background</Link> */}
                <Link to="/about/corporate-info/our-values">Our Values</Link>
                <Link to="/about/corporate-governance/compliance">
                  Compliance & AML Statement
                </Link>
              </div>
            </div>

            <div className="col-lg-2 col-12 footer-contact text-md-start">
              <h4 data-translate="footer_5_1">Our Contact</h4>
              <div className="contact-info">
                {!pathname.includes("/rize") ? (
                  <>
                    <div className="contact-row">
                      <i
                        className="bi bi-telephone-fill"
                        style={{
                          color: "rgba(0, 0, 69, 0.70)",
                          fontSize: "20px",
                        }}
                      ></i>
                      <p>
                        <b>Customer Care Hotline:</b>
                        <br />
                        <span
                          style={{
                            color: "rgba(0, 0, 69, 0.70)",
                          }}
                        >
                          +603 2332 6000
                        </span>
                      </p>
                    </div>
                    <div className="contact-row">
                      <i
                        className="bi bi-geo-alt-fill"
                        style={{
                          color: "rgba(0, 0, 69, 0.70)",
                          fontSize: "20px",
                        }}
                      ></i>
                      <p>
                        <b>
                          alrajhi bank Malaysia<br></br>
                          <Link to="/contact-us">Location</Link>
                        </b>
                      </p>
                    </div>
                    <div className="contact-row pt-4 text-center">
                      <p>
                        <b data-translate="footer_5_6">
                          Find us on social media
                        </b>
                      </p>
                    </div>
                    <div className="contact-row social-links text-center">
                      <a target="_blank" rel="noopener noreferrer" href="http://www.facebook.com/pages/Al-Rajhi-Bank-Malaysia/127604137252459">
                        <i
                          className="bi bi-facebook"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/alrajhibankmalaysia/">
                        <i
                          className="bi bi-instagram"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@alrajhibankmalaysia">
                        <i
                          className="bi bi-tiktok"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@alrajhibankMalaysiaOfficial">
                        <i
                          className="bi bi-youtube"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/arbmy"> 
                        <i
                          className="bi bi-linkedin"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="contact-row">
                      <i
                        className="bi bi-telephone-fill"
                        style={{
                          color: "rgba(0, 0, 69, 0.70)",
                          fontSize: "20px",
                        }}
                      ></i>
                      <p>
                        <b>Customer Support Line : </b>
                        <br />
                        <span
                          style={{
                            color: "rgba(0, 0, 69, 0.70)",
                          }}
                        >
                          1800 819 149 (Local toll-free)<br></br>
                          +6016 299 6610 (Local & overseas)
                        </span>
                      </p>
                    </div>
                    <div className="contact-row">
                      <i
                        className="bi bi-telephone-fill"
                        style={{
                          color: "rgba(0, 0, 69, 0.70)",
                          fontSize: "20px",
                        }}
                      ></i>
                      <p>
                        <b>Fraud Hotline (24/7) : </b>
                        <br />
                        <span
                          style={{
                            color: "rgba(0, 0, 69, 0.70)",
                          }}
                        >
                          +6016 299 5333 (Local & overseas)
                        </span>
                      </p>
                    </div>
                    <div className="contact-row">
                      <i
                        className="bi bi-envelope-fill"
                        style={{
                          color: "rgba(0, 0, 69, 0.70)",
                          fontSize: "20px",
                        }}
                      ></i>
                      <p>
                        <b>Customer Support Email : </b>
                        <br />
                        <span
                          style={{
                            color: "rgba(0, 0, 69, 0.70)",
                          }}
                        >
                          rize-cs@alrajhibank.com.my
                        </span>
                      </p>
                    </div>

                    <div className="contact-row pt-4 text-center">
                      <p>
                        <b data-translate="footer_5_6">Rize on social media</b>
                      </p>
                    </div>
                    <div className="contact-row social-links text-center">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.facebook.com/RizeMy/"
                      >
                        <i
                          className="bi bi-facebook"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/rize.my/"
                      >
                        <i
                          className="bi bi-instagram"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.tiktok.com/@rize.my"
                      >
                        <i
                          className="bi bi-tiktok"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.youtube.com/@RizeMy"
                      >
                        <i
                          className="bi bi-youtube"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.linkedin.com/company/rizemy"
                      >
                        <i
                          className="bi bi-linkedin"
                          style={{ color: "rgba(0, 0, 69, 0.70)" }}
                        ></i>
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex container flex-column flex-xl-row align-items-start border-top mt-4 pt-4 justify-content-between">
          <div className="d-flex flex-column mb-3 order-2 order-xl-1">
            <div className="d-flex flex-row flex-wrap gap-3">
              <Link to="/treat-customer-fairly-charter">
                <span>Treat Customer Fairly Charter</span>
              </Link>{" "}
              |
              <Link to="/client-charter">
                {" "}
                <span>Client Charter</span>
              </Link>
              |
              <Link to="/privacypolicy">
                {" "}
                <span>Privacy Policy</span>
              </Link>{" "}
              |
              <Link to="/tnc">
                {" "}
                <span>Terms & Conditions</span>
              </Link>{" "}
              |
              <Link to={tnc} target="_blank">
                <span>Terms of Use</span>
              </Link>
              |
              <Link to="/rize/fraud-awareness">
                <span>Fraud Awareness</span>
              </Link>
              |
              <Link to={PIDM_DIS} target="_blank">
                <span>PIDM DIS Brochure</span>
              </Link>
            </div>
            <h3 className="text-left mt-3">
              <span data-translate="footer_6_1">
                Copyright © 2024 Al Rajhi Banking & Investment Corporation
                (Malaysia) Bhd
              </span>
              <br />
              <span data-translate="footer_6_2">
                200501036909 (719057-X). All rights reserved.
              </span>
            </h3>
          </div>
          <div className="order-1 order-xl-2 mb-3 mb-xl-0">
            <img
              src={pidm_logo}
              className="d-inline-block align-top"
              alt="PIDM logo"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainFooter;
